'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var PropTypes = _interopDefault(require('prop-types'));
var FormSpacing = styled.fieldset.withConfig({
  displayName: "FormSpacing",
  componentId: "sc-18n2b3d-0"
})(["border:none;margin:", ";> *:not(:first-child){margin-top:", ";}"], function (props) {
  return props.margin;
}, function (_ref) {
  var small = _ref.small,
    theme = _ref.theme;
  return theme.type === 'secure' ? small ? '1rem' : '2rem' : small ? '1.2rem' : '2.4rem';
});
FormSpacing.propTypes = {
  /** Reduce the spacing between form elements to group them visually */
  small: PropTypes.bool,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string
};
exports.FormSpacing = FormSpacing;